var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"color":_vm.color,"dense":"","disabled":_vm.disabled,"hide-details":"","label":_vm.label,"outlined":"","value":_vm.value},on:{"change":_vm.emitChangeEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }